import styled from 'styled-components';

export const SkeletonHeaderWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
`;

export const SkeletonImageWrapper = styled.div`
    width: 20%;
`;

export const SkeletonTitleWrapper = styled.div`
    width: 15%;
`;
